<script setup>

</script>

<template>
<div>
    <span class="text-[rgba(233,232,255,1)]">Welcome to Codecourse!</span> Now you're signed up, explore the library and find something to learn.
</div>
</template>
